module.exports = __webpack_public_path__ + "static/media/surveyPopup.c728713d.png";